"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.INTERNAL_JOB_STATES = exports.OPERATION_RETENTION_CLASSES = exports.OPERATION_STATES = exports.CAPACITY_ACCESS_VALUES = exports.COLLECTION_INVITATION_RATE_CATALOGUE_VERSION = exports.COLLECTION_INVITATION_RATE_LIMITS = exports.COLLECTION_INVITATION_RATE_WINDOW_SECONDS = exports.COLLECTION_INVITATION_EXCHANGE_SECONDS = exports.COLLECTION_INVITATION_EXPIRY_SECONDS = exports.DEFAULT_COLLECTION_PEOPLE_PAGE_SIZE = exports.COLLECTION_PEOPLE_PAGE_SIZES = exports.MAX_AI_CREDITS_PER_OPERATION = exports.MAX_COLLECTION_BULK_REQUEST_BYTES = exports.MAX_COLLECTION_BULK_ITEMS = exports.INVENTORY_PROTECTED_FIELDS = exports.COLLECTION_PROTECTED_FIELDS = exports.COLLECTION_COMPATIBILITY_MODES = exports.MEMBERSHIP_STATUSES = exports.COLLECTION_ROLES = exports.COLLECTION_LIFECYCLES = exports.OPERATION_PAYLOAD_HASH_VERSION = exports.AI_CAPABILITY_HEADROOM_CAP = exports.SCHEMA_VERSION = exports.SUPPORTED_CONTRACT_VERSIONS = exports.CONTRACT_VERSION = void 0;
exports.CONTRACT_VERSION = 'collections-billing-v52';
exports.SUPPORTED_CONTRACT_VERSIONS = [exports.CONTRACT_VERSION];
exports.SCHEMA_VERSION = 1;
/** Upper bound on the AI capability `headroom` hint; it is deliberately not the wallet balance. */
exports.AI_CAPABILITY_HEADROOM_CAP = 20;
exports.OPERATION_PAYLOAD_HASH_VERSION = 'json-c14n-sha256-v1';
exports.COLLECTION_LIFECYCLES = ['active', 'deleting', 'deleted'];
exports.COLLECTION_ROLES = [
    'owner',
    'administrator',
    'editor',
    'viewer',
];
exports.MEMBERSHIP_STATUSES = ['active', 'revoked'];
/**
 * Inventory access always uses explicit collection authority.
 */
exports.COLLECTION_COMPATIBILITY_MODES = ['collection-only'];
exports.COLLECTION_PROTECTED_FIELDS = [
    'ownerUserId',
    'billingAccountId',
    'lifecycle',
    'lifecycleVersion',
    'ownershipVersion',
    'activeTransferId',
    'deletionRequestedAt',
    'permanentDeletionStartedAt',
    'deletedAt',
    'createdAt',
    'createdBy',
];
exports.INVENTORY_PROTECTED_FIELDS = [
    'collectionId',
    'ownerUserId',
    'billingAccountId',
    'operationId',
    'authorityId',
    'actorUserId',
    'capacityReservationId',
    'schemaVersion',
    'createdBy',
    'createdAt',
];
exports.MAX_COLLECTION_BULK_ITEMS = 400;
exports.MAX_COLLECTION_BULK_REQUEST_BYTES = 8 * 1024 * 1024;
exports.MAX_AI_CREDITS_PER_OPERATION = 100;
exports.COLLECTION_PEOPLE_PAGE_SIZES = [10, 25, 50];
exports.DEFAULT_COLLECTION_PEOPLE_PAGE_SIZE = 25;
exports.COLLECTION_INVITATION_EXPIRY_SECONDS = 7 * 24 * 60 * 60;
exports.COLLECTION_INVITATION_EXCHANGE_SECONDS = 30 * 60;
exports.COLLECTION_INVITATION_RATE_WINDOW_SECONDS = 60 * 60;
exports.COLLECTION_INVITATION_RATE_LIMITS = {
    owner: 30,
    collection: 40,
    email: 6,
    network: 50,
    exchangeNetwork: 120,
    exchangeToken: 12,
};
exports.COLLECTION_INVITATION_RATE_CATALOGUE_VERSION = 'invitation-abuse-v1';
exports.CAPACITY_ACCESS_VALUES = [
    'normal',
    'at-limit',
    'over-limit',
    'restricted',
    'deleting',
];
exports.OPERATION_STATES = [
    'accepted',
    'processing',
    'complete',
    'terminal',
];
exports.OPERATION_RETENTION_CLASSES = [
    'record-lifetime',
    'financial',
    'offline-window',
];
exports.INTERNAL_JOB_STATES = [
    'pending',
    'leased',
    'retryable',
    'complete',
    'dead-letter',
];
